
export default function Hebron() {
  return (
    <section className="bg-gradient-to-b from-stone-200 to-stone-100 py-24 px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-2 gap-16 items-center">
        {/* Left - Image */}
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/9060329435fb4ed1d06af4a0da0bedcb.jpg"
              alt="Hebron Industrial Gas Production Facility"
              className="w-full h-[500px] object-cover object-top"
            />
          </div>

          {/* Production Capacity Metrics */}
          <div className="absolute -bottom-6 left-6 right-6 bg-stone-50 border border-stone-200 rounded-2xl p-5 shadow-xl">
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-xl font-black">
                  LOX
                </p>
                <p className="text-stone-500 text-xs mt-0.5">Liquid Oxygen</p>
              </div>
              <div className="border-x border-stone-200">
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-xl font-black">
                  LIN
                </p>
                <p className="text-stone-500 text-xs mt-0.5">Liquid Nitrogen</p>
              </div>
              <div>
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500 text-xl font-black">
                  LAR
                </p>
                <p className="text-stone-500 text-xs mt-0.5">Liquid Argon</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Content */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full"></div>
            <span className="text-teal-600 text-sm font-bold tracking-wide uppercase">
              Ohio Infrastructure
            </span>
          </div>

          <h2 className="text-stone-800 font-black text-4xl leading-tight mb-5">
            Hebron, Ohio
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              Industrial Gas Production Facility
            </span>
          </h2>

          <p className="text-stone-600 text-base leading-relaxed mb-5">
            SkyForge is advancing site control evaluation within the Hebron industrial corridor for a dedicated ASU production facility supporting manufacturing, healthcare, and energy sector demand.
          </p>

          <p className="text-stone-600 text-base leading-relaxed mb-8">
            The Hebron site complements the Rickenbacker logistics deployment, forming a dual-node regional gas infrastructure network.
          </p>

          {/* Production Capabilities */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-xl p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-3 shadow-sm">
                <i className="ri-drop-line text-xl text-teal-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Liquid Oxygen (LOX)</p>
              <p className="text-stone-500 text-xs">
                Medical and industrial grade oxygen production
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-xl p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-11 h-11 bg-cyan-100 rounded-lg flex items-center justify-center mb-3 shadow-sm">
                <i className="ri-contrast-drop-line text-xl text-cyan-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Liquid Nitrogen (LIN)</p>
              <p className="text-stone-500 text-xs">
                Cryogenic cooling and industrial applications
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-stone-200 rounded-xl p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-11 h-11 bg-stone-200 rounded-lg flex items-center justify-center mb-3 shadow-sm">
                <i className="ri-flask-line text-xl text-teal-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Liquid Argon (LAR)</p>
              <p className="text-stone-500 text-xs">
                Welding, metal fabrication, and specialty applications
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-stone-200 rounded-xl p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-11 h-11 bg-stone-200 rounded-lg flex items-center justify-center mb-3 shadow-sm">
                <i className="ri-truck-line text-xl text-cyan-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Bulk Tanker Distribution</p>
              <p className="text-stone-500 text-xs">
                Regional delivery and logistics network
              </p>
            </div>
          </div>

          {/* Pipeline Supply Capability */}
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 border border-teal-300 rounded-2xl p-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
                <i className="ri-git-branch-line text-2xl text-white"></i>
              </div>
              <div>
                <p className="text-stone-800 font-bold text-base mb-1">
                  Pipeline Supply Capability
                </p>
                <p className="text-stone-600 text-sm">
                  Direct pipeline integration for high-volume industrial customers and dual-node regional gas infrastructure network positioning
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
